export const DEFAULT_SHIPPING = {
  zones: [
    { key: "italia", label: "Italia", free_threshold: 1500, flat_cost: 10 },
    { key: "europa", label: "Europa", free_threshold: 3000, flat_cost: 25 },
    { key: "extra_ue", label: "Oltreoceano / Extra UE", free_threshold: 6000, flat_cost: 50 },
  ],
  vat_rate: 22,
};

const ITALY = new Set(["italia", "italy", "it", "ita"]);
const EUROPE = new Set([
  "germania", "germany", "de", "francia", "france", "fr", "spagna", "spain", "es", "espana", "españa",
  "portogallo", "portugal", "pt", "austria", "at", "osterreich", "österreich", "svizzera", "switzerland",
  "ch", "suisse", "schweiz", "belgio", "belgium", "be", "belgique", "olanda", "paesi bassi", "netherlands",
  "nl", "holland", "the netherlands", "lussemburgo", "luxembourg", "lu", "regno unito", "united kingdom",
  "uk", "gb", "gran bretagna", "great britain", "england", "inghilterra", "scotland", "scozia", "irlanda",
  "ireland", "ie", "danimarca", "denmark", "dk", "svezia", "sweden", "se", "norvegia", "norway", "no",
  "finlandia", "finland", "fi", "islanda", "iceland", "is", "polonia", "poland", "pl", "repubblica ceca",
  "czech republic", "czechia", "czech", "cz", "cechia", "slovacchia", "slovakia", "sk", "slovenia", "si",
  "ungheria", "hungary", "hu", "romania", "ro", "bulgaria", "bg", "grecia", "greece", "gr", "croazia",
  "croatia", "hr", "serbia", "rs", "bosnia", "bosnia ed erzegovina", "bosnia and herzegovina", "ba",
  "montenegro", "me", "albania", "al", "macedonia", "macedonia del nord", "north macedonia", "mk",
  "kosovo", "xk", "estonia", "ee", "lettonia", "latvia", "lv", "lituania", "lithuania", "lt", "malta",
  "mt", "cipro", "cyprus", "cy", "monaco", "mc", "liechtenstein", "li", "andorra", "ad", "san marino",
  "sm", "citta del vaticano", "città del vaticano", "vaticano", "vatican", "va", "ucraina", "ukraine",
  "ua", "moldova", "moldavia", "md", "bielorussia", "belarus", "by",
]);

export function classifyZone(country) {
  const c = (country || "").trim().toLowerCase();
  if (!c || ITALY.has(c)) return "italia";
  if (EUROPE.has(c)) return "europa";
  return "extra_ue";
}

export function computeShipping(country, subtotalExcl, config) {
  const cfg = config && config.zones ? config : DEFAULT_SHIPPING;
  const zoneKey = classifyZone(country);
  const zone = cfg.zones.find((z) => z.key === zoneKey) || cfg.zones[0];
  const threshold = Number(zone.free_threshold) || 0;
  const flat = Number(zone.flat_cost) || 0;
  const isFree = threshold > 0 && (Number(subtotalExcl) || 0) >= threshold;
  return {
    zoneKey,
    zoneLabel: zone.label || "",
    threshold,
    flat,
    cost: isFree ? 0 : flat,
    isFree,
    vatRate: Number(cfg.vat_rate) || 22,
  };
}

const EU_VAT = new Set([
  "italia", "italy", "it", "ita",
  "austria", "at", "osterreich", "österreich",
  "belgio", "belgium", "be", "belgique",
  "bulgaria", "bg", "croazia", "croatia", "hr", "cipro", "cyprus", "cy",
  "repubblica ceca", "czech republic", "czechia", "czech", "cz", "cechia",
  "danimarca", "denmark", "dk", "estonia", "ee", "finlandia", "finland", "fi",
  "francia", "france", "fr", "germania", "germany", "de", "grecia", "greece", "gr",
  "ungheria", "hungary", "hu", "irlanda", "ireland", "ie", "lettonia", "latvia", "lv",
  "lituania", "lithuania", "lt", "lussemburgo", "luxembourg", "lu", "malta", "mt",
  "olanda", "paesi bassi", "netherlands", "nl", "holland", "the netherlands",
  "polonia", "poland", "pl", "portogallo", "portugal", "pt", "romania", "ro",
  "slovacchia", "slovakia", "sk", "slovenia", "si", "spagna", "spain", "es", "espana", "españa",
  "svezia", "sweden", "se",
]);

const ITALY_VAT = new Set(["italia", "italy", "it", "ita"]);

// Regime IVA B2B in base al Paese di consegna + P.IVA del rivenditore.
export function vatTreatment(country, vatNumber) {
  const c = (country || "").trim().toLowerCase();
  const hasVat = Boolean((vatNumber || "").trim());
  if (!c || ITALY_VAT.has(c)) return { exempt: false, reason: "", code: "domestic_it" };
  if (EU_VAT.has(c)) {
    if (hasVat) return { exempt: true, code: "eu_intracom", reason: "Operazione non imponibile IVA - cessione intracomunitaria (art. 41 DL 331/1993)." };
    return { exempt: false, code: "eu_no_vat", reason: "IVA italiana applicata: manca la Partita IVA per l'esenzione intracomunitaria UE." };
  }
  return { exempt: true, code: "export_extra_ue", reason: "Operazione non imponibile IVA - esportazione (art. 8 DPR 633/1972)." };
}
